import React from 'react';
const IconNavIntegrationsFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.21 1.5H7.79001L6.53 3H2V21H22V3H17.47L16.21 1.5ZM18.35 12L15.83 15H13.22L15.74 12L13.22 9H15.83L18.35 12ZM10.78 9L8.26001 12L10.78 15H8.17001L5.64999 12L8.17001 9H10.78Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconNavIntegrationsFill;